import { render } from "./AppInputFile.vue?vue&type=template&id=2cae80a0"
import script from "./AppInputFile.vue?vue&type=script&lang=js"
export * from "./AppInputFile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__